export default __webpack_public_path__ + "static/media/pdf.867e9bc4.png";